module.exports = __webpack_public_path__ + "img/prod-detail3.b160a715.jpg";